import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { adminUploadDocument, shareUrl, userlist } from "../../lib/api";

import { Spinner } from "../../shared/svgIcon";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alertDialog";

export default function Admin() {
  let navigate = useNavigate();
  const [dataset, setDataset] = useState([]);
  const [sending, setsending] = useState(false);
  const [defaultDate, setDefaultDate] = useState("");
  const [today, setToday] = useState("");
  const [flash, setFlash] = useState(false);
  const [selectedcustomer, setselectedcustomer] = useState("");

  const [uploadmodel, setUploadmodel] = useState(false);

  const [filetype, setfiletype] = useState("pdf");
  const [doctype, setDoctype] = useState("ecg");
  const [file, setFile] = useState(null);
  const [fileuploading, setFileuploading] = useState("false");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleFileChange = (e) => {
    console.log(e);
    setFile(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const documentupload = async () => {
    setFileuploading("true");
    const formData = new FormData();
    if (doctype != null && filetype != null) {
      var id = localStorage.getItem("patientId");
      formData.append("consumer_id", selectedcustomer);
      formData.append("file", file);
      formData.append("upload_type", "aws_s3");
      formData.append("doc_type", doctype);
      formData.append("file_type", filetype);
      formData.append(
        "source",
        JSON.stringify({
          identifier: "654cc54350349ba664618567",
          classification: "webapp",
          location: "",
          name: "",
        })
      );

      console.log(formData);
      const res = await adminUploadDocument(formData);
      if (res?.message == "successfully completed") {
        setUploadmodel(false);
        setFileuploading("false");
        setFlash(true);
        const timer = setTimeout(() => {
          setFlash(false);
        }, 2000); // Hide the message after 3 seconds

        return () => clearTimeout(timer);
      } else {
        setFileuploading("false");
      }
    } else {
      setFileuploading("Select all options");
    }
  };

  const getusers = async () => {
    const data = await userlist();
    if (data?.data?.data?.result) {
      setDataset(data?.data?.data?.result.slice().reverse());
    }
  };
  const uploadmodelseting = async (id) => {
    setUploadmodel(!uploadmodel);
    setselectedcustomer(id);
  };
  const shareLink = async (consumer) => {
    setsending(true);
    console.log(consumer);
    let phone = null;
    let username =
      consumer?.profile?.first_name + " " + consumer?.profile?.last_name;
    consumer?.contact.map((con, j) => {
      if (con.type == "phone") {
        phone = con.value;
      }
    });
    // const payload = {
    //        phone: phone,
    //        message: `Hi ${username}, Please sign in to visit your prognosis profile: https://app.myprognosis.ai/ - PROGNOSIS`,
    //      };
    //      const sms = await sendSms(payload);
    const payload = {
      consumer_id: consumer.id,
    };
    const sms = await shareUrl(payload);

    setsending(false);
  };
  useEffect(() => {
    getusers();
    if (!sessionStorage.getItem("adminAccessToken")) {
      navigate("/adminAccess");
    }

    const currentDate = new Date();
    setToday(currentDate.toISOString().split("T")[0]);
    currentDate.setDate(1);
    const formattedDate = currentDate.toISOString().split("T")[0];
    setDefaultDate(formattedDate);
  }, []);
  const onLogout = () => {
    setShowLogoutConfirm(true);
  };
  const logout = () => {
    sessionStorage.removeItem("adminAccessToken");
    navigate("/");
  };
  return (
    <>
      <div className=" bg-gray-50 min-h-screen">
        <div className="flex fixed  p-4 pt-4 h-16  max-w  z-50 w-full bg-white">
          <div className="flex-1">
            <img
              alt="logo"
              src="../../../images/logblck.png"
              className="mb-12  h-8"
            />
          </div>
          <div className="pl-2 pb-1 mt-2">
            <button onClick={onLogout}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="h-14"></div>
        <div className=" p-2  pt-7">
          <div className="flex p-2">
            <div className="flex-1 text-lg font-bold">Visitors List</div>
            <div className="text-xs mt-1 relative">
              <input
                type="date"
                defaultValue={defaultDate}
                className="bg-gray-200 w-24 p-1 rounded-lg text-center"
              />
            </div>
            <div className="px-2 mt-1">to</div>
            <div className="text-xs mt-1 relative">
              <input
                type="date"
                defaultValue={today}
                className="bg-gray-200 w-24 p-1 rounded-lg text-center"
              />
            </div>
          </div>
          <div className="flex flex-col mt-6 gap-4">
            {dataset?.map((i, j) => (
              <div className="flex gap-2 border p-2 py-4 shadow rounded-xl bg-blue-50 visitorlist">
                <div className="w-12 h-12 bg-gray-200 rounded-full overflow-hidden">
                  {i?.profile?.avatar_url != null && (
                    <img src={i?.profile?.avatar_url} />
                  )}
                </div>
                <div className="flex-1">
                  <h4>
                    {i?.profile?.first_name} {i?.profile?.middle_name}{" "}
                    {i?.profile?.last_name}
                  </h4>
                  <h4 className="text-xs">
                    {i.contact.map((m, n) => m.type == "email" && m.value)}
                  </h4>
                </div>
                <div className=" share-box grid grid-cols-2">
                  <button
                    className="p-2 hover:bg-blue-400 rounded-md transition-all"
                    onClick={() => shareLink(i)}
                  >
                    <img
                      src="../../../images/shareblack.png"
                      className="h-5 w-5"
                    />
                  </button>
                  <button
                    className="p-2 hover:bg-blue-400 rounded-md transition-all"
                    onClick={() => uploadmodelseting(i.id)}
                  >
                    <img src="../../../images/upload.png" className="h-5 w-5" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {sending && (
        <div className="fixed top-1/2 text-blue-800 text-lg font-medium bgb-white w-full text-center z-50 bg-blue-900 bg-opacity-25 p-4">
          Sending...
        </div>
      )}

      {uploadmodel && (
        <div className="fixed z-50 bottom-0 pb-20 p-4 pt-7 bg-white w-full rounded-t-3xl shadow-3xl border border-gray-500">
          <div className="relative flex flex-col ">
            <button
              className="absolute right-0 bg-blue-900 text-white px-1.5 rounded-full transition-all"
              onClick={() => setUploadmodel(!uploadmodel)}
            >
              ✕
            </button>
            <div className="text-lg text-blue-800 pb-3 font-bold">
              Upload Document
            </div>
            <div className="font-bold py-2">Upload Type</div>
            <select
              className="p-2 mb-5 border bg-gray-50 rounded-lg"
              value={filetype}
              onChange={(e) => setfiletype(e.target.value)}
            >
              <option value="pdf">PDF</option>
              <option value="jpg">JPG</option>
              <option value="png">PNG</option>
            </select>

            <div className="font-bold py-2">Document Type</div>
            <select
              className="p-2 mb-5 border bg-gray-50 rounded-lg"
              value={doctype}
              onChange={(e) => setDoctype(e.target.value)}
            >
              <option value="ecg">ECG Report</option>
              <option value="doctor report">Doctor Report</option>
              <option value="pharmacy">Pharmacy Report</option>
              <option value="lab report">Lab Report (Blood Test)</option>
              <option value="other">Other Report</option>
            </select>
            <div className="relative p-5 py-7 text-center bg-gray-100">
              {file != null ? (
                <>
                  <div className="text-blue-700">
                    {file.name} <span className=" font-bold">Selected</span>
                  </div>
                  <div className="font-bold">Select another file</div>
                </>
              ) : (
                <>
                  <div>Upload your document here</div>
                  <div className="font-bold">File type PDF,JPG and PNG</div>
                </>
              )}
              <input
                type="file"
                className="absolute top-0 w-full p-7 left-0 opacity-0"
                onChange={(e) => handleFileChange(e)}
              ></input>
            </div>
            <div className="text-center">
              {file != null ? (
                <button
                  className="px-6 py-2 mt-2 rounded-full bg-blue-900 text-white"
                  onClick={() => documentupload()}
                >
                  Upload
                  {fileuploading == "true" && (
                    <Spinner className="ml-2 -mt-1 h-4 w-4 animate-spin inline-block" />
                  )}
                </button>
              ) : (
                <button className="px-6 py-2 mt-2 rounded-full bg-gray-200 text-white">
                  Upload
                </button>
              )}
              {fileuploading == "Select all options" && (
                <div className="text-red-500 font-semibold">
                  Select all options before continuing
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {flash && (
        <div className="fixed z-50 py-4 w-full text-center bottom-3 bg-blue-200 text-blue-900 text-lg font-semibold rounded-xl shadow-xl">
          Document Uploaded successfully.
        </div>
      )}

      <AlertDialog open={showLogoutConfirm} onOpenChange={setShowLogoutConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Log Out</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to log out?.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={logout}>Yes</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
